import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
// import ImageGridFront from './layout/portfolio/ImageGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import Paragraph from './layout/Paragraph';
import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

import ProcessThreeSteps from './layout/Process';

import DeviceGridCustom from './layout/portfolio/DeviceGridCustom';
import DeviceMockupVideo from './layout/portfolio/DeviceMockupVideo';
import DeviceMockup from './layout/portfolio/DeviceMockup';

import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx2 from './layout/portfolio/ImageGridx2';

import GalleryGridx1 from './layout/portfolio/GalleryGridx1';
import VideoGridx1 from './layout/portfolio/VideoGridx1';

import VideoGridFront from './layout/portfolio/VideoGridFront';

import PenIcon from './asset/PenIcon';
import Front from './img/ittybittyapps/reveal.mp4';
import AboutIBA from './img/ittybittyapps/ic_ibaguys@2x.png';

// Reveal
import Reveal_1 from './img/ittybittyapps/RevealIcon@2x.png';
import Reveal_3 from './img/ittybittyapps/reveal_cover@2x.jpg';
import Reveal_4 from './img/ittybittyapps/reveal-icon-before@2x.png';
import Reveal_5 from './img/ittybittyapps/RevealIcon2@2x.png';

// AIA Vitality
import AIA_1 from './img/aia/vitality_loading.mp4';
import AIA_2 from './img/aia/AIA_main@2x.png';
import AIA_3 from './img/aia/AIA_reward.mp4';

// Snapshot
import Snapshot_1 from './img/ittybittyapps/snapshot-sample@2x.jpg';
import Snapshot_2 from './img/ittybittyapps/snapshot-sample1.png';
import Snapshot_3_vid from './img/ittybittyapps/snapshot-sample3.mp4';
import Snapshot_3 from './img/ittybittyapps/snapshot-sample3.png';

import Supp_1 from './img/ittybittyapps/Supp_payment.mp4';

// Summary
const companyInfo = {
  title: "Creating beautiful software",
  name: "Itty Bitty Apps",
  themeColor: "#181818",
  themeTextColor: "#ffffff",
  frontImage: Front,
  role: "Mid-Senior Product Designer",
  fields: "Mobile apps",
  time: "Feb 2015 – Mar 2017",
}

// how I stated working at the company
const workContent =
{
  description: "Itty Bitty Apps is an independent software company, known for its iOS inspector app Reveal. I served as a UX/UI designer for the consulting projects, and also contributed to the design of Reveal."
}

// Responsibilities
const list = ['Consulted the best design practices for corporate to SME clients.', 'Refreshed existing mobile experience to improve user engagements.', 'Designed in-house software/service with collaboration with developers.', 'Conducted user testings for on-site clients.', 'Mentoring at conferences and meetings for best design practices.']

// About itty bitty apps
const aboutIttyBitty = {
  summary: "ABOUT THE COMPANY",
  image: AboutIBA,
  title: "Who are Itty Bitty Apps?",
  paragraph: "Itty Bitty Apps is a software company specialised in developing mobile apps. Unlike the name, the company has a big reputation in Australia’s iOS development scene. The business also offers consultancy to firms, helping them to create mobile apps with the best practice in design and engineering.",
  themeColor: "#1d3557",
  textColor: "#ffffff",
}

// #1 - Talking about design process
const IBAReveal ={
  summary: "Reveal App",
  heading:"Reveal is created to help developers and designers to look everything behind the app. The color, position, and all the fine details.",
  paragraph: "We say the devil is in the detail. For app design, we often call it pixel perfect. However, the process to get to the pixel perfection, or even knowing what style has been used... can be challenging. \n\nReveal was created to help both designer and developers to create beautiful apps with ease. With Reveal, you can see the colours, x and y positions, and how each component is nested together without reading the code. To be able to work on Reveal was one of the most attractive reason to join the team.",
  heading_2: "The most interesting tasks I did for the app was to refresh the app icon.",
  paragraph_2:"Back in 2014, the new macOS(Yosemite) brought a major aesthetic change – The flat design! Along with the update, many Mac apps updated their icons with 'the glyph in a circle'. When it came to update Reveal's look and feel, I needed to think about which direction we should go with.",
  paragraph_3:" I wanted the icon to look fresh while protecting the original shape. It was all about finding out a balance between the trend and the existing identity of our product. Learning how to re-interpret the trend in order to secure the personality of the product was the most memorable experience.",
  caption_1: "Reveal is for developers and designers who care details. You can rotate, zoom, and turn your screen into 3D to see what's underneath. ",
  caption_2:"The Before/After – I made many subtle changes in the lighting, texture, and focal.",
  caption_3:"For the developers who go to WWDC and other conference events, I also designed fun t-shirt graphic. 🤓"
}

// Project case study
const IBAProject = {
  summary: "Design Consulting",
  titleIcon: PenIcon,
  heading: "From small to large scale projects, I worked cross-functionally with code, design, and strategy to build great experiences.",
  paragraph: "My passion was to help clients by improving their mobile experience. Every project was different because they had unique problems to solve. I found it rewarding to analyse the problems and overcome them with engineering, design, and research.",
  paragraph_2:"The unique aspect of being a designer at Itty Bitty Apps was the collaboration with software developers. Unlike a typical design-to-development process, everyone could utilise developer tools as well as design tools – Git, Xcode, Sketch and so on. Working with transparently and being agile with changes helped us to be the differentiator.",
  themeColor: '#D15171',
  textColor: '#ffffff',
}

// Project case study
const AIAVitality = {
  image_1: AIA_1,
  image_2: AIA_2,
  image_3: AIA_3,
  summary:    "AIA Vitality Australia",
  heading:    "Wellness program for rewarding the healthy habits",
  paragraph:  "AIA Vitality is a wellness program that incentives the members for healthier life choices. I was responsible for redesign the initial app, aimed to create a more intuitive and engaging user experience.\n\nThere were lots of unknowns as we started building the app from scratch. Collaboration with the business stakeholders and UX researchers were helping us to overcome the technical difficulty. The app has successfully launched and contributed to the growth of the program in the Australian market.",
  themeColor: "#BF4958",
  textColor:  "#ffffff"
}

const Snapshot = {
  summary: "Dulux Snapshot",
  heading:    "A companion app to find the nearest Dulux paint with Dulux Snapshot®",
  paragraph:  "Dulux Snapshot is a portable colour digitiser to scan a surface to find a matching colour paint. It's designed to help builders and painters to easily find the matching paint. Itty Bitty Apps was partnered with Palette, the company that designed the hardware, to create the iOS companion app. I designed the interface and experience.\n\nGiven the device was created for professional painters, we wanted to make sure the interface can fit their workflow. Features like renaming the colours and creating a group with multiple colours were created with consideration of real use cases. The project was rewarded with multiple design awards for its user-friendliness.",
  themeColor: '#ffffff',
  textColor: '#333333',
}

// Project case study
const Supp = {
  video_1: Supp_1,
  summary: "Supp",
  heading: "Jobs marketplace for verified hospitality professionals",
  paragraph: "Supp is a platform to connect small businesses to hospitality professionals. The goal was to help restaurants, cafes, and bars to quickly find qualified staff to fill the roaster by streamlining the payment system and employment process. I contributed the project by setting up the backbone of payment and job searching interface.",
  themeColor: '#E17236',
  textColor: '#ffffff',
}


const metatag = {
  title: "Portfolio ✴︎ " + companyInfo.name,
  author: "Jinju Jang",
  url: "http://jinju.io/ittybittyapps",
  description: companyInfo.paragraph,
  image: "http://jinju.io" + Reveal_1
}

class PortfolioSportsmate extends Component {
  render() {
    return (
      <div>
        {/*Meta data*/}
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{metatag.title}</title>
          <meta name="author" content={metatag.author}/>
          <meta name="description" content={metatag.description}/>

          {/*-- Google / Search Engine Tags --*/}
          <meta itemprop="name" content={metatag.title}/>
          <meta itemprop="description" content={metatag.description}/>
          <meta itemprop="image" content={metatag.image}/>

          {/*-- Open Graph / Facebook --*/}
          <meta property="og:url" content={metatag.url}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={metatag.title} />
          <meta property="og:description" content={metatag.description}/>
          <meta property="og:image" content={metatag.image}/>

          {/*-- Twitter --*/}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={metatag.title}/>
          <meta name="twitter:description" content={metatag.description}/>
          <meta name="twitter:image" content={metatag.image}/>
       </Helmet>

        <Navigation />
        {/*Front page*/}
        <VideoGridFront first={Front} title={companyInfo.title} themeColor={companyInfo.themeColor} textColor={companyInfo.themeTextColor}/>
        {/*Position summary*/}
        <ProjectInfo
          title={companyInfo.name}
          role={companyInfo.role}
          fields={companyInfo.fields}
          description={workContent.description}
          time={companyInfo.time}
          dotPoints={list}/>

        {/*Who are IBA*/}
        <ImageGridx1
          first={aboutIttyBitty.image}
          innerDescription={<BriefIcon summary={aboutIttyBitty.summary} titleIcon={<PenIcon color={aboutIttyBitty.textColor}/>}
          title={aboutIttyBitty.title}
          paragraph={aboutIttyBitty.paragraph} textColor={aboutIttyBitty.textColor}/>}themeColor={aboutIttyBitty.themeColor}
          showTriangle
        />

        {/*----- About reveal ------*/}
        <Paragraph
          titleText={IBAReveal.summary}
          heading={IBAReveal.heading}
          paragraph={IBAReveal.paragraph}
        />
        <ImageGridx1
          first={Reveal_3}
          caption={IBAReveal.caption_1}
        />
        <Paragraph
          heading={IBAReveal.heading_2}
          paragraph={IBAReveal.paragraph_2 + "\n\n" + IBAReveal.paragraph_3}
        />

        <ImageGridx2
          first={Reveal_4}
          second={Reveal_1}
          caption={IBAReveal.caption_2}
        />
        <GalleryGridx1
          first={Reveal_5}
          caption={IBAReveal.caption_3}
        />
        {/*----- About proejcts ------*/}
        <Paragraph
          titleText={IBAProject.summary}
          heading={IBAProject.heading}
          paragraph={IBAProject.paragraph + "\n\n" + IBAProject.paragraph_2} />

        {/*----- three points ------*/}
        <ProcessThreeSteps
          heading="Highlights"
          first={AIAVitality.summary}
          firstDetail={AIAVitality.heading}
          second={Snapshot.summary}
          secondDetail={Snapshot.heading}
          third={Supp.summary}
          thirdDetail={Supp.heading} />

        {/*----- AIA Vitality ------*/}
        <ImageGridx1
          first={AIA_3}
          innerDescription={<BriefIcon summary={AIAVitality.summary}
          title={AIAVitality.heading}
          paragraph={AIAVitality.paragraph} textColor={AIAVitality.textColor}/>}themeColor={AIAVitality.themeColor}
          extra={<DeviceGridCustom
            first={<DeviceMockup screenshot={AIAVitality.image_2}/>}
            second={<DeviceMockupVideo video={AIAVitality.image_1}/>}/>}
          showTriangle/>

        {/*----- Dulux Snapshot ------*/}
        <ImageGridx1
          first={Snapshot_1}
          caption="The app instantly shows the colour the device captures. You can get three closest matches, and also rename or move the colour to a group."
          innerDescription={<BriefIcon summary={Snapshot.summary}
          title={Snapshot.heading}
          paragraph={Snapshot.paragraph} textColor={Snapshot.textColor}/>}
          extra={ <DeviceGridCustom first={<DeviceMockup screenshot={Snapshot_2}/>} second={<DeviceMockupVideo video={Snapshot_3_vid} poster={Snapshot_3}/>} themeColor={Snapshot.themeColor}/>}
        />

        {/*----- Supp ------*/}
        <VideoGridx1
          first={Supp.video_1}
          innerDescription={<BriefIcon summary={Supp.summary}
          title={Supp.heading}
          paragraph={Supp.paragraph} textColor={Supp.textColor}/>}themeColor={Supp.themeColor}
          showTriangle
        />
        <NextUp
          previous="Outware Mobile"
          previousURL="/outware"
          next="Sportsmate"
          nextURL="/sportsmate"
        />
        <WarpLarge />
        <Footer/>
      </div>
    );
  }
}

export default PortfolioSportsmate;



// WEBPACK FOOTER //
// ./src/PortfolioIBA.js